export const rowIndentationFormulaCSS = `calc(var(--left-pad) + var(--depth) * var(--step))`
